import { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import PreguntasFrecuentes from './pages/PreguntasFrecuentes'
import Home from './pages/Home'
import Layout from './pages/Layout';
import Asociarme from './pages/Asociarme';
import SolicitarTecnico from './pages/SolicitarTecnico';
import LandingPage from './pages/Landing';
import Welcome from './pages/welcome';

export default function App() {
  return (
    <BrowserRouter scrollBehavior="auto">
      <ScrollHandler />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
          <Route path="/asociarme" element={<Asociarme />} />
          <Route path="/servicios" element={<SolicitarTecnico />} />
          <Route path="/bienvenida" element={<Welcome />} />
        </Route>
        <Route path="/landing" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}


function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}